// employeService.js
import { employeAPI } from './restaurantAPI';

const employeService = {
  // Get all employes
  async getAll(params = {}) {
    try {
      const response = await employeAPI.getAll(params);
      console.log('Employe API Response:', response);
      return response.data;
    } catch (error) {
      console.error('Error in employeService.getAll:', error);
      throw error;
    }
  },

  // Get single employe
  async get(id) {
    try {
      const response = await employeAPI.getById(id);
      return response.data;
    } catch (error) {
      console.error('Error in employeService.get:', error);
      throw error;
    }
  },

  // Create new employe
  async create(data) {
    try {
      console.log('Creating employe with data:', data);
      const response = await employeAPI.create(data);
      return response.data;
    } catch (error) {
      console.error('Error in employeService.create:', error);
      throw error;
    }
  },

  // Update employe
  async update(id, data) {
    try {
      const response = await employeAPI.update(id, data);
      return response.data;
    } catch (error) {
      console.error('Error in employeService.update:', error);
      throw error;
    }
  },

  // Delete employe
  async delete(id) {
    try {
      const response = await employeAPI.delete(id);
      return response.data;
    } catch (error) {
      console.error('Error in employeService.delete:', error);
      throw error;
    }
  },

  // End contract
  async endContract(id, date) {
    try {
      const response = await employeAPI.endContract(id, date);
      return response.data;
    } catch (error) {
      console.error('Error in employeService.endContract:', error);
      throw error;
    }
  },

  // Get statistics
  async getStats() {
    try {
      const response = await employeAPI.getAll();
      const employes = response.data;
      
      const stats = {
        total: employes.length,
        actifs: employes.filter(e => e.est_actif).length,
        inactifs: employes.filter(e => !e.est_actif).length,
        totalSalaire: employes
          .filter(e => e.est_actif)
          .reduce((sum, e) => sum + (parseFloat(e.salaire) || 0), 0),
        parPoste: {
          cuisinier: employes.filter(e => e.poste === 'cuisinier' && e.est_actif).length,
          serveur: employes.filter(e => e.poste === 'serveur' && e.est_actif).length,
          barman: employes.filter(e => e.poste === 'barman' && e.est_actif).length,
          femme_chambre: employes.filter(e => e.poste === 'femme_chambre' && e.est_actif).length,
          autre: employes.filter(e => e.poste === 'autre' && e.est_actif).length
        }
      };
      
      return stats;
    } catch (error) {
      console.error('Error in employeService.getStats:', error);
      throw error;
    }
  },

  // Search employes
  async search(query) {
    try {
      const response = await employeAPI.getAll();
      const allEmployes = response.data;
      
      return allEmployes.filter(employe => {
        const searchStr = query.toLowerCase();
        return (
          employe.nom.toLowerCase().includes(searchStr) ||
          employe.prenom.toLowerCase().includes(searchStr) ||
          employe.telephone.includes(query) ||
          employe.email.toLowerCase().includes(searchStr) ||
          employe.poste.toLowerCase().includes(searchStr)
        );
      });
    } catch (error) {
      console.error('Error in employeService.search:', error);
      throw error;
    }
  }
};

export default employeService;